import Header from "./Compartido/Header";
import TextoCancelado from "./Compartido/TextoCancelado";
import BrandsSection from "./Compartido/BrandsSection";
import Hero from "./Compartido/Hero";
import Footer from "./Compartido/Footer";

const CanceladoPaypal = (props) => {
    return (
        <>
            <main className="min-h-screen">
                <Header
                    config={props.websgrupo}
                    lang={props.lang}
                    meta_titulo={props.meta_titulo}
                    meta_descripcion={props.meta_descripcion}
                    meta_keywords={props.meta_keywords}
                    ruta={props.ruta}
                    idiomas={props.idiomas}
                    destinos={props.destinos}
                    experiencias={props.experiencias}
                />
                <Hero
                    eltexto={props.textosobrenosotros}
                    ruta={props.ruta}
                    laseccion="Pago Cancelado"
                />
                <TextoCancelado
                    config={props.websgrupo}
                />
            </main>

            <app-footer>
                <BrandsSection
                    lang={props.lang}
                    marcas={props.marcas}
                    ruta={props.ruta}
                />
                <Footer
                    lang={props.lang}
                    config={props.websgrupo}
                />
            </app-footer>
        </>
    );
}

export default CanceladoPaypal;
